<template>
  <div class='mb-6'>
    <v-divider />
    <v-btn :disabled='!disabled' color='primary' outlined class='mb-5' @click='appendChild' left>Расходы</v-btn>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th v-for='key of keys'>{{ key | upper }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for='(item,index) of items' :key='index'>
          <td>{{ index + 1 }}</td>
          <td>
            <v-text-field
              :disabled='!disabled'
              @input='calculate'
              :rules='[required]'
              v-model='item.Expenses1'
              class='mt-6'
              type='number'
              outlined
              dense
            />
          </td>
          <td>
            <v-text-field
              :disabled='!disabled'
              @input='calculate'
              :rules='[required]'
              type='number'
              v-model='item.Expenses2' class='mt-6'
              outlined
              dense
            />
          </td>
          <td>
            <v-btn :disabled='!disabled' @click='remove(index)'  color='red' icon>
              <v-icon color='red'>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider />
  </div>

</template>

<script>
export default {
  props: {
    items: Array,
    disabled: Boolean,
    call: Function
  },
  components: {
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  data() {
    return {
      keys: [
        '#', 'Расходы1', 'Расходы2', 'Удалить'
      ],
      input: { isEdit: this.disabled },
      required: (value) => !!value || 'Это поля не может быть пустым',
      number: (value) => isNaN(parseFloat(value)) ? 'Можно вести только числа' : true
    }
  },
  methods: {
    appendChild() {
      this.items.push({
        Expenses1: '',
        Expenses2: ''
      })
    },
    calculate() {
      this.call(this.items)
    },
    remove(index) {
      this.items.splice(index, 1)


      // this.$emit('consignment', this.items)
    }
  },
  filters: {
    upper: (value) => value.toUpperCase()
  }
}
</script>